import { render, staticRenderFns } from "./don-melchor.vue?vue&type=template&id=724efa14&scoped=true"
import script from "./don-melchor.vue?vue&type=script&lang=js"
export * from "./don-melchor.vue?vue&type=script&lang=js"
import style0 from "./don-melchor.vue?vue&type=style&index=0&id=724efa14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724efa14",
  null
  
)

export default component.exports